module.exports = __webpack_public_path__ + "static/media/news_feed_active.42aa64a3.svg";